// extracted by mini-css-extract-plugin
export default {"container":"UserProfileButton_container__LUeW2","avatar":"UserProfileButton_avatar__kGDVB","name":"UserProfileButton_name__8uX5m"};